import React, { FC } from 'react'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { internalLinkHandler } from '../../../../utils/link.utils'
import { FooterLegal } from '../style'
import { Security_Logo } from '../utils/footerLogos'

type Props = {
  legalLinks: any
  socialData: any
  langCode: string
}

const Legal: FC<Props> = ({ legalLinks, socialData, langCode }) => {
  return (
    <FooterLegal>
      <ul>
        {legalLinks.map((item: any, index: number) => {
          return (
            <li key={index}>
              <a
                href={
                  item?.internalLink ? internalLinkHandler(item?.internalLink) : item?.externalUrl
                }
                key={index}>
                {item?.text}
              </a>
            </li>
          )
        })}

        <li>
          {langCode === LocaleCodes.CHINESE.code ? (
            <a id="ot-sdk-btn" className="ot-sdk-show-settings" rel="noopener">
              {socialData.COOKIE_SETTING}
            </a>
          ) : (
            <a id="ot-sdk-btn" className="ot-sdk-show-settings" rel="noopener">
              View cookie settings
            </a>
          )}
        </li>
      </ul>

      {langCode !== LocaleCodes.CHINESE.code ? <p>{socialData.DISCLAIMER_FOOTER_TEXT}</p> : ''}

      <p>
        {langCode === LocaleCodes.CHINESE.code ? (
          <>
            <a
              href={socialData.ICP_NUMBER_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="nohover">
              {socialData.ICP_NUMBER}
            </a>

            <a href={socialData.SECURITY_NUMBER_LINK} target="_blank" className="nohover">
              {Security_Logo}
              {socialData.SECURITY_NUMBER}
            </a>
          </>
        ) : null}
        {` © 2005-${new Date().getFullYear()} ${socialData.RIGHTS_RESERVED}`}
      </p>
    </FooterLegal>
  )
}

export default Legal
